export default function ShippingHomeIcon() {
  return (
    <>
      <g id='Frame' clipPath='url(#clip0_3720_226293)'>
        <path
          id='Vector'
          d='M6.66667 16H4L16 4L28 16H25.3333'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M6.67188 16V25.3333C6.67188 26.0406 6.95283 26.7189 7.45292 27.219C7.95302 27.719 8.6313 28 9.33854 28H22.6719C23.3791 28 24.0574 27.719 24.5575 27.219C25.0576 26.7189 25.3385 26.0406 25.3385 25.3333V16'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_3'
          d='M12 27.9948V19.9948C12 19.2875 12.281 18.6093 12.781 18.1092C13.2811 17.6091 13.9594 17.3281 14.6667 17.3281H17.3333C18.0406 17.3281 18.7189 17.6091 19.219 18.1092C19.719 18.6093 20 19.2875 20 19.9948V27.9948'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3720_226293'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </>
  );
}
